import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doPROFILE_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROFILE_IMAGE_UPLOAD = "REQUEST_PROFILE_IMAGE_UPLOAD";
export const doREQUEST_PROFILE_IMAGE_UPLOAD = createDoRequestAction(REQUEST_PROFILE_IMAGE_UPLOAD);

export const requestProfileImageUploadActionCreators = {
  doREQUEST_PROFILE_IMAGE_UPLOAD,
};

export function* requestProfileImageUpload({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*profileImageUpload");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        image: v.any().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROFILE_IMAGE_UPLOAD,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { image } = payload;

  const accessToken = yield call(getToken);

  const formData = new FormData();
  formData.append("image", image);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/profile-image-upload`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${accessToken}`,
    },
    data: formData,
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROFILE_IMAGE_UPLOAD,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/profile-image-upload",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doPROFILE_SET(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROFILE_IMAGE_UPLOAD,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* profileImageUploadSaga() {
  yield takeEvery(REQUEST_PROFILE_IMAGE_UPLOAD, requestProfileImageUpload);
}
